import './Share.scss'
import { Card } from 'react-bootstrap'
import { isAndroid, isiOS } from 'components/common/helpers/Mobile'

export default function Share() {
  const handleShareClick = async () => {
    let text = 'Check out Remble: Relationship Health'
    let url =
      'https://www.remble.com/?utm_source=app&utm_medium=remble_share_link'

    if (isiOS()) {
      text += ' on the Apple App Store'
      url =
        'https://apps.apple.com/pl/app/remble-relationship-health/id1597957847'
    } else if (isAndroid()) {
      text += ' on the Google Play Store'
      url = 'https://play.google.com/store/apps/details?id=com.remble.android'
    }

    try {
      await navigator.share({
        title: 'Remble: Relationship Health',
        text,
        url
      })
    } catch (e) {
      // Swallow exceptions, since user may abort share
      console.error(e)
    }
  }

  return (
    <div className='share-wrapper'>
      <Card className='share-card' onClick={() => handleShareClick()}>
        <Card.Body>
          <div className='media d-flex'>
            <div className='media-body text-left'>
              <h4>Invite friends</h4>
              <span>Share Remble with friends and family</span>
            </div>
            <div className='text-right'>
              <i className='bi bi-share-fill'></i>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}
